/** Formátování podle českých zvyklostí: desetinná čárka, mezera před značkou. */

export function pct(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "–";
  return `${(value * 100).toFixed(digits).replace(".", ",")} %`;
}

export function signedPct(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "–";
  const text = pct(Math.abs(value), digits);
  return value >= 0 ? `+${text}` : `−${text}`;
}

export function odds(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "–";
  return Number(value).toFixed(2).replace(".", ",");
}

export function money(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "–";
  return `${Math.round(Number(value)).toLocaleString("cs-CZ")} Kč`;
}

/** Doba v lidsky čitelném tvaru, bez sekund u dlouhých intervalů. */
export function duration(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000));
  const days = Math.floor(total / 86_400);
  const hours = Math.floor((total % 86_400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  if (days > 0) return `${days} d ${hours} h`;
  if (hours > 0) return `${hours} h ${minutes} min`;
  if (minutes > 0) return `${minutes} min ${seconds} s`;
  return `${seconds} s`;
}

export function signClass(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "";
  return value > 0 ? "pos" : value < 0 ? "neg" : "";
}

const OUTCOME_LABEL: Record<string, string> = {
  HOME: "domácí", DRAW: "remíza", AWAY: "hosté", OVER: "více", UNDER: "méně",
};

export function outcome(code: string): string {
  return OUTCOME_LABEL[code] ?? code;
}
